import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import candidatesReducer from './candidatesSlice';
import eventsReducer from './eventsSlice';
import fileStorageReducer from './fileStorageSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  candidates: candidatesReducer,
  events: eventsReducer,
  fileStorage: fileStorageReducer,
});

export const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;